import axios from 'axios';
import { getSelectedSede } from '../utils/sede';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true, // Importante: enviar cookies automáticamente
});

// Multi sede: la sede elegida por el ADMIN viaja en cada petición
axiosInstance.interceptors.request.use((config) => {
    const sedeId = getSelectedSede();
    if (sedeId) {
        config.headers.set('X-Sede-Id', sedeId);
    }
    return config;
});

// Interceptor para manejar errores de respuesta
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Sesión expirada o no autenticado
            const publicRoutes = ['/login', '/forgot-password', '/reset-password'];
            const isPublicRoute = publicRoutes.some(route => window.location.pathname.includes(route));

            // Solo redirigir si no estamos ya en una ruta pública
            if (!isPublicRoute) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
